/**
 * 訪談附件檔名搜尋 hook — REQ-20260419010。
 */
import { useQuery } from '@tanstack/react-query';
import type { AttachmentSearchResponse } from '@app/shared';
import { apiClient } from '../../lib/api-client';

export function useAttachmentSearch(q: string) {
  const trimmed = q.trim();
  return useQuery({
    queryKey: ['attachment-search', trimmed],
    enabled: trimmed.length > 0,
    queryFn: async (): Promise<AttachmentSearchResponse> => {
      const res = await apiClient.get<AttachmentSearchResponse>('/attachments/search', {
        params: { q: trimmed },
      });
      return res.data;
    },
  });
}
